export enum BreadcrumbsName {
  Catalog = 'Каталог',
  Basket = 'Корзина',
  Main = 'Главная'
}
